module.exports = __webpack_public_path__ + "img/culture3.c5026f38.jpg";